import React from 'react';
import { setClassNames } from '@ddc/classnames-js';
import PropTypes from 'prop-types';

const StickySide = ({ children, className }) => {
	return (
		<>
			<div className={setClassNames([className, 'position-absolute'])}>
				{children}
			</div>
			{/* Work as placeholder to take space */}
			<div
				className={setClassNames([className, 'opacity-0 placeholder'])}
				role="presentation"
				aria-hidden="true"
				inert="true"
			>
				{children}
			</div>
		</>
	);
};

StickySide.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string
};

export default StickySide;
